import { useDispatch } from 'react-redux';
import { hideTooltip, showTooltip } from '../../components/tooltips/tooltipActions';
import { useCallback, useRef } from 'react';
import randomString from '../../../common/uid/randomString';
import { TooltipPositions } from '../../components/tooltips/tooltipConstants';
import classNames from 'classnames';
import platformSingleton from '../../platform/platformSingleton';
import { useTranslator } from '../../components/i18n/useTranslator';

const useBoardNavigationTooltip = ({ elementId }: { elementId: string }) => {
    const dispatch = useDispatch();
    const stableTooltipId = useRef(`tip-${randomString(6)}`);
    const translate = useTranslator('onboarding', 'tooltips.boardNavigation');

    const dispatchShowNavigationTooltip = () => {
        const message = platformSingleton.features.isTouch ? translate('doubleTapText') : translate('doubleClickText');

        dispatch(
            showTooltip({
                id: stableTooltipId.current,
                tooltip: {
                    selector: `#el-${elementId} .BoardIcon`,
                    text: message,
                    position: TooltipPositions.TOP,
                    duration: 2000,
                    fade: true,
                    className: classNames('Tooltip', 'small'),
                    delay: 500,
                    pollPosition: true,
                    hideOnEvent: 'pointerdown',
                },
            }),
        );
    };

    const dispatchHideNavigationTooltip = useCallback(() => {
        dispatch(hideTooltip(stableTooltipId.current));
    }, []);

    return {
        dispatchShowNavigationTooltip,
        dispatchHideNavigationTooltip,
    };
};

export default useBoardNavigationTooltip;
